import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: '_.access_user_approved_view.header',
        defaultMessage:
            '{businessName} has been approved for {offeredAmount} — valid until {timeoutDate}'
    },
    cta: {
        id: '_.access_user_approved_view.cta',
        defaultMessage: 'Continue'
    },
    CTAinfo: {
        id: '_.access_user_approved_view.cta_info_text',
        defaultMessage:
            'Before we can send funds to {businessName}, we need you to complete a few final steps.'
    },
    activeConsentCTA: {
        id: '_.access_user_approved_view.active_consent_cta',
        defaultMessage: 'Confirm'
    },
    activeConsentCTAInfo: {
        id: '_.access_user_approved_view.active_consent_cta_info_text',
        defaultMessage:
            'I understand that any personal guarantee I have given in relation to borrowings with iwoca will apply to the total balance of all loans. I have either obtained independent legal advice or chosen to continue without it.'
    }
});
